import { render } from "./Footer_Section.vue?vue&type=template&id=31b85f90&scoped=true"
import script from "./Footer_Section.vue?vue&type=script&lang=js"
export * from "./Footer_Section.vue?vue&type=script&lang=js"

import "./Footer_Section.vue?vue&type=style&index=0&id=31b85f90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b85f90"]])

export default __exports__